<template>
  <Card id="service-card">
    <template v-slot:content>
      <div class="grid-container">
        <div class="type">
          <ServiceType :background="getServiceTypeColor(service)">
            <span style="font-weight: 600">
              {{ getServiceTypePath(service) }}
              <span style="font-weight: 900; padding-left: 6px">
                #{{ service.id }}</span
              >
            </span>
          </ServiceType>
        </div>
        <div class="card-field date">
          <span class="material-icons">event</span>
          <p style="display: inline">
            {{ $formatDate(service.dateStart) || '-' }}
            <template v-if="service.dateEnd">
              - {{ $formatDate(service.dateEnd) }}
            </template>
          </p>
        </div>
        <div class="card-field bovine-count">
          <span class="p-mr-2 p-pt-1"><IconBovine /></span>
          <span v-if="service.bovineCount > 1"
            >{{ service.bovineCount }} Bovinos</span
          >
          <span v-else-if="service.bovineCount"
            >{{ service.bovineCount }} Bovino</span
          >
          <span v-else>-</span>
        </div>
        <div class="card-field value">
          <span class="material-icons">attach_money</span>
          <p style="display: inline">
            {{ $toDecimal(service.totalValue) }}
            - {{ $toDecimal(service.bovineValue) }} por bovino
          </p>
        </div>
        <div class="card-field other-account">
          <span class="material-icons" style="color: #396df4">
            assignment_ind
          </span>
          <p>
            {{ service?.customer?.name || service?.vet?.name || '-' }}
          </p>
        </div>
        <div class="farm card-field">
          <span class="material-icons">map</span>
          <p class="text-field-overflow" v-tooltip.top="getFarmName(service)">
            {{ getFarmName(service) || '-' }}
          </p>
        </div>
        <div class="card-field status">
          <span class="material-icons"> info </span>
          <p>
            <ServiceSituation :data="service"></ServiceSituation>
          </p>
        </div>
        <div class="card-field">
          <BovineTypeSummary
            class="p-mt-1"
            :bovinesTypes="service.bovinesTypes"
          ></BovineTypeSummary>
        </div>
        <div class="card-field bull">
          <span><IconBull /></span>
          <p>
            {{ getInseminatedText(service) }}
          </p>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import ServiceType from './ServiceType.vue';
import IconBovine from '../../../components/icon/IconBovine.vue';
import ServiceSituation from './ServiceSituation.vue';
import IconBull from '../../../components/icon/IconBull.vue';
import BovineTypeSummary from '../../../components/BovineTypeSummary.vue';

export default {
  name: 'SaleCard',
  components: {
    BovineTypeSummary,
    ServiceType,
    IconBovine,
    IconBull,
    ServiceSituation,
  },
  props: {
    service: Object,
  },
  methods: {
    getServiceTypeColor(service) {
      return (service.customerService || service)?.type?.color;
    },
    getServiceTypePath(service) {
      return (service.customerService || service)?.type?.path;
    },
    getInseminatedText(data) {
      const bulls = (data.customerService || data).bulls || [];
      if (!bulls.length) {
        return '-';
      }
      return bulls.map((bull) => `${bull.name}(${bull.count})`).join(', ');
    },
    getFarmName(data) {
      return (data.customerService || data)?.farm?.name;
    },
  },
};
</script>

<style scoped>
#service-card >>> .p-card-content {
  padding: 0 !important;
}
.card-field span {
  padding-right: 10px;
}
.card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 0.5em 1em;
  grid-template-areas:
    '. .'
    '. .'
    '. .'
    '. .';
}

@media (min-width: 800px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      '. . .'
      '. . .'
      '. . .';
  }
}

@media (min-width: 1024px) {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1.3fr 1.3fr 1fr 1fr;
    grid-template-rows: 1fr max-content;
    gap: 1em 1em;
    grid-template-areas:
      '. . . . .'
      '. . . . .';
  }
}

.bull p {
  display: inline;
}
</style>
